"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VenueDataGridPageActions;
(function (VenueDataGridPageActions) {
    VenueDataGridPageActions["DataLoaded"] = "DataLoaded";
})(VenueDataGridPageActions || (VenueDataGridPageActions = {}));
exports.default = VenueDataGridPageActions;
